export const SHOW_LAZY = 'SHOW_LAZY';
export const HIDE_LAZY = 'HIDE_LAZY';
